function filterDropdown() {
    let input = document.getElementsByClassName("searchable-dropdown-toggle")[0]
    input.placeholder = "Select a course to link"
    let filter = input.value.toUpperCase();
    let div = document.getElementsByClassName("searchable-dropdown-menu")[0];
    let elementsArray = div.getElementsByClassName("dropdown-item-filterable");
    for (let i = 0; i < elementsArray.length; i++) {
        let txtValue = elementsArray[i].textContent || elementsArray[i].innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            elementsArray[i].style.display = "";
        } else {
            elementsArray[i].style.display = "none";
        }
    }}

document.addEventListener('turbolinks:load', function() {
    $(".dropdown-item-filterable").on("click", function() {
        let dataName = $(this).data("name");
        let dataId = $(this).data("id");
        $(".search-field").val(dataName);
        $(".search-field").addClass("fw-bold");
        $("#record-name").val(dataName);
        $("#record-id").val(dataId);
        $("#link-course-submit").attr("disabled", false)
    })

    $("#course-selection").on("show.bs.dropdown", function(){
        $(".search-field").val("");
        filterDropdown();
        $(".search-field").removeClass("fw-bold");
    })

    $(".search-field").on("keyup", function(){
        filterDropdown();
    })

    $(".search-field").on("blur", function(){
    })

    $(".dropdown").on("hidden.bs.dropdown", function(){
        $(".search-field").val($("#record-name").val());
        if($("#record-name").val()){
            $(".search-field").addClass("fw-bold");
        }
    })

})